import { isGuidePath } from '@/utils/publicPaths'

// 무활동 세션 타임아웃 정책 (시간 단위)
// 관리자(어드민 대행 로그인)와 일반 셀러 모두 12시간으로 통일한다.
export const SESSION_TIMEOUT_HOUR_ADMIN = 12
export const SESSION_TIMEOUT_HOUR_SELLER = 12

// localStorage 의 sessionTime(마지막 요청 시각) 기준으로 무활동 타임아웃 초과 여부 판정
// - sessionTime 이 없으면 만료 아님 (첫 요청)
// - 개발환경 예외: 현재 이 repo 에는 .env.development 가 없고 .env 의 NODE_ENV=staging 이
//   우선하므로 NODE_ENV 가 'development' 가 되는 경우는 없다(= 항상 false).
//   기존 동작 보존을 위해 조건은 유지한다.
export const isSessionExpired = (isAdmin: boolean): boolean => {
  const sessionTime = localStorage.getItem('sessionTime')
  if (!sessionTime) return false
  if (process.env.NODE_ENV === 'development') return false
  // 공개 가이드(/guide) 는 로그인 없이 보는 화면 — 오래된 sessionTime 때문에 /logout 으로 튕기면 안 된다
  if (isGuidePath(window.location.pathname)) return false

  const diffTime = new Date().getTime() - Number(sessionTime)
  const diffHour = Math.floor(diffTime / 1000 / 60 / 60)
  const timeoutHour = isAdmin ? SESSION_TIMEOUT_HOUR_ADMIN : SESSION_TIMEOUT_HOUR_SELLER

  return diffHour >= timeoutHour
}

// 요청마다 마지막 요청 시각(sessionTime) 갱신 — main.ts 인터셉터·Api 클래스 공통
// - 비로그인(토큰 없음) 방문에는 세션을 만들지 않는다
// - 공개 가이드(/guide) 에서는 만료 판정을 건너뛰므로 갱신도 하지 않는다.
//   갱신하면 만료된 세션이 가이드 방문만으로 되살아난다 (보호 화면으로 돌아가면 그대로 만료 처리)
export const touchSessionTime = (): void => {
  if (!localStorage.getItem('accessToken')) return
  if (isGuidePath(window.location.pathname)) return
  localStorage.setItem('sessionTime', String(new Date().getTime()))
}
